import styled from 'styled-components';
import { backgroundImage, flex } from '@/styles/minix';
import { colorGroup } from '@/styles/common';
import dateIcon from '@/images/common/date-picker.svg';

export const PSearchToolWrap = styled.div`
	padding: 0 12px;
	height: 100%;
	background: #fff;
	.tools-title {
		font-size: 16px;
		height: 50px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		color: ${colorGroup.textInferior};
		border-bottom: 1px solid ${colorGroup.lineSlight};
	}
	.tools-content {
		height: calc(100% - 50px);
		${flex('row', 'space-between', 'center')};
		padding: 20px 0;

		.tools--wrap {
			${flex('row', 'flex-start', 'center')};

			& .tool-item {
				> .ant-select {
					min-width: 100px;
					width: auto;
				}

				:not(:first-child) {
					margin-left: 15px;
				}
			}
			.ant-form-item {
				margin-bottom: 0px;
			}
			.ant-input {
				:hover {
					border: 1px solid #dfe1e6;
				}
			}
		}

		.btn--wrap {
			.ant-btn {
				margin-left: 15px;
			}
		}

		& .icon-calendar {
			width: 12px;
			height: 12px;
			${backgroundImage(dateIcon)}
		}
	}
`;
